(function () {
  var mediaQuery = window.matchMedia('(max-width: 749px)');
  var emptyTextStyleId = 'zoalin-mobile-reviews-empty-text-position-20260719-title-js';

  function shouldRun() {
    return mediaQuery.matches && document.body.classList.contains('template-product');
  }

  function applyReviewTitleCentering() {
    if (!shouldRun()) return;

    var root = document.querySelector('#judgeme_product_reviews');
    if (!root) return;

    var title = root.querySelector('.jm-review-widget-minimal-header__title');
    var titleStack = title && title.closest('.jm-stack--space-200');
    var titleCluster = title && title.closest('.jm-cluster');

    [titleCluster, titleStack, title].forEach(function (node) {
      if (!node) return;
      node.style.setProperty('width', '100%', 'important');
      node.style.setProperty('max-width', '100%', 'important');
      node.style.setProperty('margin-left', 'auto', 'important');
      node.style.setProperty('margin-right', 'auto', 'important');
      node.style.setProperty('text-align', 'center', 'important');
    });

    if (titleCluster) {
      titleCluster.style.setProperty('display', 'flex', 'important');
      titleCluster.style.setProperty('justify-content', 'center', 'important');
      titleCluster.style.setProperty('align-items', 'center', 'important');
      titleCluster.style.setProperty('--jm-cluster-justify', 'center', 'important');
    }

    applyReviewEmptyTextPosition(root);
  }

  function ensureEmptyTextStyle() {
    if (document.getElementById(emptyTextStyleId)) return;

    var style = document.createElement('style');
    style.id = emptyTextStyleId;
    style.textContent = [
      '/* ZOALIN_MOBILE_REVIEWS_EMPTY_TEXT_POSITION_20260719_TITLE_JS_V2 */',
      '@media(max-width:749px){',
      'html body.template-product #judgeme_product_reviews .jm-no-reviews-state{width:100%!important;max-width:100%!important;margin:-4px auto 0!important;justify-items:center!important;text-align:center!important;}',
      'html body.template-product #judgeme_product_reviews .jm-no-reviews-state__text{display:block!important;width:100%!important;max-width:100%!important;margin:-2px auto 0!important;text-align:center!important;transform:translateY(-4px)!important;}',
      'html body.template-product #judgeme_product_reviews .jm-no-reviews-state__action-buttons{justify-content:center!important;margin-top:6px!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function applyReviewEmptyTextPosition(root) {
    ensureEmptyTextStyle();

    var state = root.querySelector('.jm-no-reviews-state');
    var text = root.querySelector('.jm-no-reviews-state__text');
    var actions = root.querySelector('.jm-no-reviews-state__action-buttons');

    if (state) {
      state.style.setProperty('width', '100%', 'important');
      state.style.setProperty('max-width', '100%', 'important');
      state.style.setProperty('margin', '-4px auto 0', 'important');
      state.style.setProperty('justify-items', 'center', 'important');
      state.style.setProperty('text-align', 'center', 'important');
    }

    if (text) {
      text.style.setProperty('display', 'block', 'important');
      text.style.setProperty('width', '100%', 'important');
      text.style.setProperty('max-width', '100%', 'important');
      text.style.setProperty('margin', '-2px auto 0', 'important');
      text.style.setProperty('text-align', 'center', 'important');
      text.style.setProperty('transform', 'translateY(-4px)', 'important');
    }

    if (actions) {
      actions.style.setProperty('justify-content', 'center', 'important');
      actions.style.setProperty('margin-top', '6px', 'important');
    }
  }

  function start() {
    applyReviewTitleCentering();
    window.setTimeout(applyReviewTitleCentering, 250);
    window.setTimeout(applyReviewTitleCentering, 900);
    window.setTimeout(applyReviewTitleCentering, 1800);

    var observer = new MutationObserver(applyReviewTitleCentering);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('load', applyReviewTitleCentering);
  mediaQuery.addEventListener('change', applyReviewTitleCentering);
})();
